import { render, staticRenderFns } from "./CompetitionCertificate.vue?vue&type=template&id=c563d812&scoped=true&"
import script from "./CompetitionCertificate.vue?vue&type=script&lang=js&"
export * from "./CompetitionCertificate.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionCertificate.vue?vue&type=style&index=0&id=c563d812&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c563d812",
  null
  
)

export default component.exports